<template>
  <div>
    <card shadow>
      <div slot="header" class="bg-white border-0">
        <div class="row align-items-center">
          <div class="col-8">
            <h3 class="mb-0">Contatar suporte</h3>
          </div>
        </div>
      </div>
      <template>
        <form role="form" class="vld-parent" ref="support_form">
          <div class="row ml-2">
            <div class="col-lg-12">
              <label class="form-control-label">
                No que podemos te ajudar?
              </label>
              <div>
                <base-input addon-left-icon="ni ni-support-16">
                  <select class="form-control" v-model="model.category">
                    <option selected disabled value="">
                      Selecione um motivo
                    </option>
                    <option
                      v-for="category in supportCategories"
                      :key="category.key"
                      :value="category.key"
                    >
                      {{ category.value }}
                    </option>
                  </select>
                </base-input>
              </div>
            </div>
            <div class="col-lg-12">
              <base-input
                label="Assunto"
                placeholder="Digite o assunto"
                v-model="model.subject"
              />
            </div>
          </div>
          <hr class="mt-2 mb-4" />
          <div class="row ml-2">
            <div class="col-lg-12">
              <label class="form-control-label"> Descrição </label>
              <div class="sp-container-edditable">
                <quill-editor
                  v-model="model.description"
                  :options="editorEdittable"
                >
                </quill-editor>
              </div>
            </div>
          </div>
          <div class="row ml-2">
            <div class="col-12">
              <base-alert
                type="danger"
                class="text-center mt-4 mb-0"
                v-if="error"
                ><i class="fas fa-exclamation-circle mr-1"></i>
                {{ error }}</base-alert
              >
              <base-alert
                v-if="success"
                type="success"
                class="text-center mt-4 mb-0"
                ><i class="fas fa-thumbs-up mr-1"></i> {{ success }}</base-alert
              >
            </div>
            <div class="col-12 mt-4 text-right">
              <base-button type="primary" :custom="true" @click="handleSubmit"
                >Enviar mensagem</base-button
              >
            </div>
          </div>
        </form>
      </template>
    </card>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import api from "@/services/api.js";

export default {
  name: "support-form",
  components: {
    quillEditor,
  },
  data() {
    return {
      model: {
        category: "",
        subject: "",
        description: "",
      },
      supportCategories: [
        {
          key: "general_question",
          value: "Dúvida de usabilidade",
        },
        {
          key: "bug_report",
          value: "Reportar problema",
        },
        {
          key: "my_account",
          value: "Minha conta",
        },
        {
          key: "feature_request",
          value: "Sugerir funcionalidade",
        },
        {
          key: "feedback",
          value: "Dar feedback",
        },
        {
          key: "other",
          value: "Outro",
        },
      ],
      editorEdittable: {
        placeholder:
          "Descreva aqui o motivo de seu contato. Para que possamos lhe atender da melhor forma, forneça todos os detalhes possíveis (lembre-se, se necessário, você pode linkar arquivos pelo editor).",
      },
      success: "",
      error: "",
    };
  },
  methods: {
    async handleSubmit(e) {
      e.preventDefault();
      this.error = this.success = "";
      const data = this.model;
      if (!data.category || !data.subject || !data.description) {
        this.error = "Por favor, preencha todos os campos antes de continuar.";
        return;
      }
      const loader = this.$loading.show({
        container: this.$refs.support_form,
        width: 160,
        height: 160,
      });
      try {
        await api.post("/support-messages", data);
        this.model.category = this.model.subject = this.model.description = "";
        this.success =
          "Mensagem enviada com sucesso. Fique tranquilo, se necessário, entraremos em contato! :)";
        this.$toasted.show("Mensagem enviada com sucesso");
      } catch (e) {
        this.error =
          "Ocorreu ao enviar a mensagem, verifique as informações e tente novamente.";
        this.$toasted.error("Ocorreu ao enviar a mensagem");
      } finally {
        loader.hide();
      }
    },
  },
};
</script>
<style>
p > strong {
  font-weight: bold !important;
}

.sp-container-edditable .quill-editor .ql-container,
.sp-container-edditable .quill-editor .ql-container .ql-editor {
  min-height: 10rem;
  width: 100%;
}
</style>
